export default [
  {
    summary: "Frühdienst",
    location: "Solitudestraße 20, 70839 Gerlingen",
    description: "Frühdienst 6:20 Uhr bis 12:20 Uhr.",
    start: "05:00",
    end: "13:00",
    attendees: [{ email: "Hans-Peter.Bock@trumpf.com" }],
    reminders: {
      useDefault: false,
      overrides: [
        // { method: "email", minutes: 24 * 60 },
        { method: "popup", minutes: 5 },
      ],
    },
  },
  {
    summary: "Spätdienst",
    location: "Solitudestraße 20, 70839 Gerlingen",
    description: "Spätdienst von ... Uhr bis ... Uhr.",
    start: "11:00",
    end: "20:00",
    attendees: [{ email: "Hans-Peter.Bock@trumpf.com" }],
    reminders: {
      useDefault: false,
      overrides: [
        // { method: "email", minutes: 24 * 60 },
        { method: "popup", minutes: 5 },
      ],
    },
  },
  {
    summary: "Wochenenddienst",
    location: "Solitudestraße 20, 70839 Gerlingen",
    description: "Wochenenddienst von ... Uhr bis ... Uhr.",
    start: "09:00",
    end: "19:00",
    attendees: [{ email: "Hans-Peter.Bock@trumpf.com" }],
    reminders: {
      useDefault: false,
      overrides: [
        // { method: "email", minutes: 24 * 60 },
        { method: "popup", minutes: 5 },
      ],
    },
  },
];
